// var axios = require("axios");
//
// const user = JSON.parse(window.localStorage.getItem('auth.currentUser'));
//
// var header = {};
//
// if (user && user.token) {
//   header = {
//     'Authorization' : 'Bearer ' + user.token,
//     'Accept': "application/json",
//   }
// }
//
// var axiosInstance = axios.create({
//   baseURL: process.env.VUE_APP_API_URL,
//   headers: header
//   /* other custom settings */
// });
//
// module.exports = axiosInstance;

import store from '@state/store'
import axios from 'axios'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
})

http.interceptors.request.use(
    request => {
      const user = JSON.parse(window.localStorage.getItem('auth.currentUser'));

      if (user && user.token) {
        request.headers.common['Authorization'] = 'Bearer '+user.token;
      }
      return request
    },
    error => {
        if (error.response.status === 401) {
            store.dispatch('auth/logOut')
            this.$router.push("/login");
        }

      return Promise.reject(error)
    }
)

export default http